import { Component, OnInit, Inject } from '@angular/core';
import { AlertsService, FacilityService, MessageService, UserService } from 'src/app/services';
import { UserDetail, AccessUserInfo } from 'src/app/models';
import { LoaderService } from 'src/app/services/loader.service';


@Component({
  selector: 'bart-alert-manager',
  templateUrl: './alert-manager.component.html',
  styleUrls: ['./alert-manager.component.scss']
})
export class AlertManagerComponent implements OnInit {

  public USERNAME:string;
  public BARTROLECODE:string;
  public BARTROLEID:Number
  public USERID:Number
  public ALERTSTATUSCODE= 'Cancelled';
  public txtKeyword:string='';
  public cols: any[];
  public selectedData: any;
  public alerts = [];
  public displayCancelAlertConfirm: boolean = false;
  public cancelAlertSuccess: boolean = false;
  public createAlertsModel = { alertMessage: '', dateActive: '', dateExpires: '',alertType : [] };
  public tblDivision: any[];
  public tblRegion: any[];
  public tblFacility: any[];
  public tblUser: any[];
  public locData:any;
  public userLocationDivision: any[];
  public userLocationRegion: any[];
  public userLocationFacilities: any[];
  public UserDetails: any[];  
  public selectedDivisionData: any[];
  public selectedRegionData: any[];
  public selectedFacilityData: any[];
  public selectedUserData: any[];
  public createAlertSuccess: boolean = false;
  public userInfo:UserDetail;
  public Content:string;
  public displayInputModal: boolean = false;
  showGlobalLoader:boolean=false
  alertTypes: { name: string; code: string; }[];
  constructor(
    private _AlertManagerService: AlertsService,
    private _facilityService: FacilityService,
    private _userService: UserService,
    private _loaderService : LoaderService,
    private messageService: MessageService
    ) 
  {   
      this.userInfo = AccessUserInfo.getUserInfo();    
  }

  
  ngOnInit() {

    this.USERNAME = this.userInfo.userName  
    this.BARTROLECODE = this.userInfo.bartRoleCode;
    this.BARTROLEID= this.userInfo.bartRoleId;
    this.USERID = this.userInfo.userId;
  
    this.cols =[
      {field: 'dateActive', Header: 'Visible Date', display: 'table-cell'},
      {field: 'alertTypeCode', Header: 'Type', display: 'table-cell'},
      {field: 'alertStatusCode', Header: 'Status', display: 'table-cell'},
      {field: 'alertGroupName', Header: 'Group', display: 'table-cell'},
      {field: 'alertDetail', Header: 'Detail', display: 'table-cell'},
      {field: 'divisionName', Header: 'Division', display: 'table-cell'},
      {field: 'regionName', Header: 'Region', display: 'table-cell'},
      {field: 'facilityName', Header: 'Location', display: 'table-cell'},
      {field: 'userName', Header: 'User', display: 'table-cell'}
     
    ];

    this.tblDivision = [
      {field: 'DivisionNumber', Header: 'Number'},
      {field: 'DivisionName', Header: 'Division Name'} 
    ];
    
    this.tblRegion = [
      {field: 'RegionNumber', Header: 'Number'},
      {field: 'RegionName', Header: 'Region Name'}
    ];
    
    this.tblFacility = [
      {field: 'FacilityNumber', Header: 'Number'},
      {field: 'FacilityName', Header: 'Location Name'}
    ];
    this.tblUser = [
      {field: 'userRole', Header: 'Role'},
      {field: 'username', Header: 'User Name'},
      {field: 'lastname', Header: 'Last Name'},
      {field: 'firstname', Header: 'First Name'}
    ];
    this.alertTypes = [
      {name: 'Service Request', code: 'SR'},
      {name: 'Lab', code: 'Lab'},
     
  ];
    this.getUserLocation();
    this.getUserData();
  }
  public searchAlerts()
  {
    this.alerts= [];
    this.selectedData=null;
    this._loaderService.show();
    let bartrolecode = this.BARTROLECODE;
    let bartroleId = this.BARTROLEID;
    let userId = this.USERID;
    let userName = this.USERNAME;

  if(this.txtKeyword=='' || this.txtKeyword=="undefined" || this.txtKeyword==null)
  {
   // this.messageService.showAlertMessage("Error:Search term must be at least three characters.");  
    this._loaderService.hide();
   // return false;
  }
  else{
    var searchAlertsParams = {
      
      'SEARCHALERTS':
      {
        'BARTROLECODE': bartrolecode,
        'BARTROLEID': bartroleId,
        'USERID': userId,
        'USERNAME': userName,
        'SEARCHTERM':this.txtKeyword
        
      }
    };

    this._AlertManagerService.getSearchAlert(JSON.stringify(searchAlertsParams)).subscribe((data: any) => {
      this.alerts = data;
      this.alerts=this.alerts.sort((a, b) => b.alertId- a.alertId);
      this._loaderService.hide(); 
     }),
    (respose: Response) => {  
     this._loaderService.hide();        
     // handle error here
   }  
   this.getUserData();
  }
  };

  public cancelAlert() {
    this.displayCancelAlertConfirm = true;
  }
  closeClick(eventId: string) {
    this.displayInputModal = false;

  }
  public cancelAlertConfirm(obj){
    
    let alertStatusCode = this.ALERTSTATUSCODE;
    let userId = this.USERID;
    var param = {
      "SETALERTSTATUS":
     {
       "ALERTSTATUSCODE": alertStatusCode,
       "USERID": userId,
       "ALERTID": obj.alertId
     }
   };
   this._AlertManagerService.cancelAlert(JSON.stringify(param)).toPromise().then((data) => {
       console.log(data);
     });     
     this.cancelAlertSuccess = true;
     this.alerts = [];
     this.selectedData = null;
     this.searchAlerts();
     this.displayCancelAlertConfirm = false;
  }
  public getUserLocation(){
    let userName = this.USERNAME

    var getLocationParam = { 
                "GETUSERLOCATIONS": { 
                  "LOCATION_ID_LIST": "",
                  "USERNAME": userName
                }, 
                "GETUSERLOCATIONS2": { 
                  "USERNAME": userName
                }
              }

              this._facilityService.getUserLocations(JSON.stringify(getLocationParam)).subscribe((allUserLocationsResponse:any) => {
                this.locData=allUserLocationsResponse;
                this.userLocationDivision=[];
                this.userLocationDivision = this.locData.divisions;  
                this.userLocationRegion=[];
                this.userLocationRegion=this.locData.regions;
                this.userLocationFacilities=[];
                this.userLocationFacilities=this.locData.facilities;      
              },(respose: Response) => {           
                
              });
  }  
  OkClose()  
  {    
    this.createAlertSuccess = false;   
   
  }
  public getUserData(){  
    let bartrolecode = this.BARTROLECODE;
    let GETUSERS = {
      "BARTROLECODE": bartrolecode
    }

    this._userService.getUsers(JSON.stringify({GETUSERS})).subscribe((allUserData: any) => {
      this.UserDetails = allUserData;
    }),
    (respose: Response) => { }
  }; 


  public resetData()
  {
    this.createAlertsModel.dateActive = null;
    this.createAlertsModel.dateExpires = null;
    this.createAlertsModel.alertMessage = null;    
    this.createAlertsModel.alertType = null; 
  }

  createAlertManager() {  
    this._loaderService.show();
      let userID = this.USERID
      this.showGlobalLoader=true
      var division=[];
      if(this.selectedDivisionData !=undefined){
        division = this.selectedDivisionData.map(x=>x.DivisionMasterID);
        var divisionDetail = division.join(",");
      }
      
      var region=[];
      if(this.selectedRegionData != undefined){
        region = this.selectedRegionData.map(x=>x.RegionMasterID);
        var regionDetail = region.join(",");
      }
      
      var Facility=[];
      if(this.selectedFacilityData != undefined){
        Facility =this.selectedFacilityData.map(x=>x.FacilityMasterID);
        var facilityDetail = Facility.join(",");
      }
      
      var User = [];
      if(this.selectedUserData !=undefined){
        User = this.selectedUserData.map(x=>x.userId)
        var UserDetail = User.join(",");
      }
      if(this.createAlertsModel.alertType != null){
        this.createAlertsModel.alertType.map(x=>x.name)
      }
      let CreateAlert = {
        alertObject:'',
        userId:userID,    
        UserIds:UserDetail, 
        FacilityMasterId:facilityDetail, 
        DivisionMasterId:divisionDetail, 
        RegionMasterId:regionDetail,     
        AlertPriorityId:1,
        DateActive:this.createAlertsModel.dateActive,
        DateExpires:this.createAlertsModel.dateExpires,
        AlertDetail:this.createAlertsModel.alertMessage,
        alertCategory :this.createAlertsModel.alertType ? (this.createAlertsModel.alertType.map(x=>x.name)).join(",") :( this.createAlertsModel.alertType == null) ? "Service Request" : "Service Request"
      };
      
      this._AlertManagerService.createAlert(JSON.stringify({CreateAlert})).subscribe((data) => {
     
        this.showGlobalLoader=false
        this.getUserLocation();
        this.getUserData();     
        this.createAlertSuccess = true;
        this.selectedDivisionData=[];
        this.selectedRegionData=[];
        this.selectedFacilityData=[];
        this.selectedUserData=[];
        this._loaderService.hide();
      },
      (erro=>{
        this._loaderService.hide();
        this.showGlobalLoader=false
      }));
      this.resetData();
     
  }
  parsedText(text) {
    const dom = new DOMParser().parseFromString(
    '<!doctype html><body>' + text,
    'text/html');
    const decodedString = dom.body.textContent;
    return decodedString;
  }

}
